const NavLinks = {
  MANAGE_VENDORS: '/managevendors',
  MANAGE_VENDORS_DETAIL: '/managevendors/detail',
  MANAGE_VENDORS_USER_GROUP: '/managevendors/usergroup',
  MANAGE_VENDORS_USER_GROUP_ADD: '/managevendors/usergroup/add'
};

export default NavLinks;